/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/hemp.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.mesh_1.geometry}
				material={materials["Material.005"]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane082.geometry}
				material={materials["Material.005"]}
				position={[-0.04, 2.041, -0.019]}
				rotation={[Math.PI / 2, 0, -Math.PI]}
				scale={0.462}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder019.geometry}
				material={materials["Clay Soil.001"]}
				position={[-0.031, 0.04, -0.034]}
				scale={0.573}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder018.geometry}
				material={materials["MDF Pau Ferro - Guararapis*.001"]}
				position={[-0.041, 0.214, -0.046]}
				scale={[0.589, 1.656, 0.589]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder.geometry}
				material={materials["Material.006"]}
				position={[-0.052, 0.945, 0.012]}
				scale={[0.007, 0.638, 0.007]}
			/>
		</group>
	);
}

useGLTF.preload("models/hemp.glb");
